import { checkoutOptimizationStepArraySchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod";

export const getCheckoutTreeFlowStepsByEventId = {
  name: "getCheckoutTreeFlowStepsByEventId" as const,
  input: z.object({ checkoutTreeId: z.string(), eventId: z.string() }),
  output: z.object({
    steps: checkoutOptimizationStepArraySchema,
    isActive: z.boolean(),
    label: z.string(),
  }),
};
